const App_Config={
    server_url:'https://bookstoreserver-eu20.onrender.com'
}
export default App_Config